module.exports = __webpack_public_path__ + "static/media/logo.39058f28.png";